// extracted by mini-css-extract-plugin
export var arrows = "_6g-6";
export var decrementer = "_6g-a";
export var disabled = "_6g-4";
export var error = "_6g-1";
export var hiddenText = "_6g-b";
export var incrementer = "_6g-9";
export var input = "_6g-8";
export var inputWrapper = "_6g-0";
export var leadingIcon = "_6g-c";
export var readonly = "_6g-3";
export var regular = "_6g-7";
export var small = "_6g-5";
export var warning = "_6g-2";